import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataService , LandingPaginationDTO } from "src/app/bpg-common/services/data.services";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Router } from '@angular/router';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { ConstantValues } from "src/app/bpg-common/models/bpg-constants";
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-naac-home-page',
  templateUrl: './naac-home-page.component.html',
  styleUrls: ['./naac-home-page.component.css']
})

export class NaacHomePageComponent implements OnInit {
  adminId: any = localStorage.getItem('adminId');
  selectedNaacId: any = Number(localStorage.getItem("selectedNaacId"));
  selectedNaacName: any = localStorage.getItem("selectedNaacName");;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();

  naacDetailsList: any = [];
  imageURL = '';
  visionStatement = '';
  affinityGoal = '';
  naacLogo = ''
  naacNewsList: any = [];
  selectedNewsList: any = [];

  Maxmin = '+';
  naacFolderList: any = [];
  selectedFolder: any = [];
  naacResourceList: any = [];
  selectedResourceList: any = [];
  fileList: any = [];
  flag2 = false;

  naacReTeamList: any = [];
  selectedReTeamList: any = [];

  //map section
  mapDetailsList: any = [];
  totalMembershipCount: any;
  totalSites: any;
  totalChapters: any;
  bpgId: number;
  siteDetails: any = [];

  eventList: any = [];

  //summary section
  selectedSite: any = 0;
  siteListforBpg: any = [];
  naacAffinityId: any = localStorage.getItem("naacAffinityId");
  minDate: any;
  maxDate: any;
  currentYearDisplay: any;
  nextYearDisplay: number;
  checkYear = 'currentFiscalYear';
  calculateYear = 'currentFiscalYear';
  summaryDetails: any = [];
  hoshinStatus: string;
  fiscalYear: any;
  chapterEmail: any;
  isNaacAdmin  = false;

  // events section
  eventdetails1: string;

  eventId: string;
  hideArrow = false;

  eventName: string;
  eventDetails = [];
  iconKeyList: any;
  upcomingeventsinfo: any = [];
  fontFamily = 'Montserrat-light';

  @ViewChild("areaMapUSA", { static: true }) areaMapUSA: ElementRef;
  @ViewChild("areaMapCanada", { static: true }) areaMapCanada: ElementRef;
  @ViewChild("areaMapMexico", { static: true }) areaMapMexico: ElementRef;

  /**
   * @class BpgChapterHomePageComponent
   * @constructor
   */
  constructor(
    private readonly  data: DataService,
    private readonly router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    
    private readonly environment: EnvironmentConfiguration,
    private readonly naacService: SelfService,
    private readonly datePipe: DatePipe,
    private readonly sanitizer : DomSanitizer

  ) {

  }

  ngOnInit() {
    this.spinnerService.show();
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    this.data.selectedNaacIdForNaacMenu.subscribe(_myData => {
      this.currentYearDisplay = new Date().getFullYear().toString().slice(2, 4);
      this.nextYearDisplay = parseInt(this.currentYearDisplay) + 1;
      if (new Date().getMonth() >= 3) {
        this.currentYearDisplay = this.nextYearDisplay;
        this.nextYearDisplay += 1;
      }
      if(localStorage.getItem('isNaacAdmin') === 'true')
      {
        this.isNaacAdmin = true;
      }
      this.spinnerService.hide();
      this.getnaacBannerList();
      this.getnaacFolderList();
      this.getNaacResouceList();
      this.getnaacnewsList();
      this.getnaacREteam();
      this.getMapDetails();
      this.getnaacSites();
      this.getnaacSummary('currentFiscalYear');
      this.getEventDetails();
      this.selectedSite = 0;
    }
    )
  }

  /** get naac site list
* @class NaacComponent
* @method getnaacSites
*/
  getnaacSites() {

    this.LandingPaginationDTO = {
      "filter": { "naacAffinityId": this.naacAffinityId },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.naacService.getsiteDetails(this.LandingPaginationDTO).subscribe(data => {
      this.siteListforBpg = data;
      if (this.siteListforBpg.length > 0) {
        this.siteListforBpg.unshift({ siteId: 0, siteName: 'All Chapters' });
      }
    })
  }


  /** get naac summary details
* @class NaacComponent
* @method getnaacSummary
*/
  getnaacSummary(value) {

    this.calculateYear = value
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    if (this.calculateYear === 'currentFiscalYear') {
      if (month < 3) {
        this.minDate = new Date(`${year-1}/04/01`);
        this.maxDate = new Date(`${year}/03/31`);
        this.fiscalYear = new Date().getFullYear();
      }
      else if (month >= 3) {
        this.minDate = new Date(`${year}/04/01`);
        this.maxDate = new Date(`${year+1}/03/31`);
        this.fiscalYear = new Date().getFullYear() + 1;
      }
    }
    else if (this.calculateYear === 'nextFiscalYear') {
      if (month >= 3) {
        this.minDate = new Date(`${year+1}/04/01`);
        this.maxDate = new Date(`${year+2}/03/31`);
        this.fiscalYear = new Date().getFullYear() + 2;
      }
      else if (month < 3) {
        this.minDate = new Date(`${year}/04/01`);
        this.maxDate = new Date(`${year+1}/03/31`);
        this.fiscalYear = new Date().getFullYear() + 1;
      }
    }
    let summaryData;
    if (this.selectedSite != null || this.selectedSite !== undefined) {
      summaryData = {
        siteId: this.selectedSite,
        naacAffinityId: this.naacAffinityId,
        fromDate: this.minDate,
        toDate: this.maxDate,
        fiscalYear: this.fiscalYear
      }
    }
    else {
      summaryData = {
        siteId: 0,
        naacAffinityId: this.naacAffinityId,
        fromDate: this.minDate,
        toDate: this.maxDate,
        fiscalYear: this.fiscalYear
      }
    }

    this.naacService.getSummaryDetails(summaryData).subscribe(data => {
      this.summaryDetails = data;
      this.hoshinStatus = this.summaryDetails.budgetHoshinStatus;
      this.selectedSite = this.summaryDetails.siteId;
      this.chapterEmail = this.summaryDetails.chapterEmail;
      this.summaryDetails.totalExpense = this.summaryDetails.totalExpense === null ? 0 : this.summaryDetails.totalExpense;
      if (this.hoshinStatus === 'SUBMITTED' || this.hoshinStatus === 'APPROVED'
        || this.hoshinStatus === 'DRAFT' || this.hoshinStatus === 'REJECTED') {
        this.summaryDetails.noHoshin = false;
      }
      else{
        this.summaryDetails.noHoshin = true;
      }
    })

  }

  /** open outlook to send email to chapter Admins
* @class NaacComponent
* @method contactUs
*/
  contactUs() {
    window.location.assign("mailto:" + this.chapterEmail);
  }

  /** get list of sites for map
* @class NaacComponent
* @method getMapDetails
*/
  getMapDetails() {
    this.spinnerService.show();
    const mapData = {
      "filter": { "naacId": this.selectedNaacId },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.naacService.getMapDataforNaac(mapData).subscribe(data => {
      this.mapDetailsList = data;
      if (this.mapDetailsList != null && this.mapDetailsList !== undefined) {
        const mapArrayUSA = [];
        const mapArrayCanada = [];
        const mapArrayMexico = [];
        this.totalMembershipCount = this.mapDetailsList.totalMembershipCount;
        this.totalSites = this.mapDetailsList.totalSites;
        this.totalChapters = this.mapDetailsList.totalChapters;
        for (const map of this.mapDetailsList.siteMasterDTO) {

          if (map.countryName === "USA"){
            mapArrayUSA.push({ "z": map.membershipCount, "membershipCount": map.membershipCount, "parentState": map.siteName, "lat": map.siteLatitude, "lon": map.siteLongitude });
          }
          if (map.countryName === "Canada"){
            mapArrayCanada.push({ "z": map.membershipCount, "membershipCount": map.membershipCount, "parentState": map.siteName, "lat": map.siteLatitude, "lon": map.siteLongitude });
          }
            if (map.countryName === "Mexico"){
            mapArrayMexico.push({ "z": map.membershipCount, "membershipCount": map.membershipCount, "parentState": map.siteName, "lat": map.siteLatitude, "lon": map.siteLongitude });
          }
          }

        {
          const HighchartsUSA = require('highcharts/highmaps.js'),
            USAmap = require('@highcharts/map-collection/countries/us/custom/us-all-mainland.geo.json');
          HighchartsUSA.mapChart(this.areaMapUSA.nativeElement, {
            chart: {
              type: 'map',
              height: 370,
              width: 370,
              backgroundColor: 'lightgray'
            },
            title: {
              useHTML: true,
              text: "<img src='/assets/images/usaflag.png'    height='19px' width='32px'/>  USA",
              verticalAlign: 'bottom',
              style: {
                fontFamily: this.fontFamily,
                fontWeight: 'bold',
                marginLeft: '8px',
                color: 'black',
              },
            },

            tooltip: {
              formatter: function () {
               return `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`;
              }
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },

            series: [{
              name: 'Basemap',
              mapData: USAmap,
              borderColor: '#f1a691 ',
              nullColor: 'white',
              showInLegend: false
            }, {
              type: 'mapbubble',
              data: mapArrayUSA,
              maxSize: '5%',
              color: '#b62027 '
            }]

          }
          );
        }
        //canada select all
        {
          const HighchartsCanada = require('highcharts/highmaps.js'),
            Canadamap = require('@highcharts/map-collection/countries/ca/ca-all.geo.json');
          HighchartsCanada.mapChart(this.areaMapCanada.nativeElement, {
            chart: {
              type: 'map',
              height: 370,
              width: 370,
              backgroundColor: 'lightgray'
            },
            title: {
              useHTML: true,
              text: "<img src='/assets/images/canadaflag.png'    height='19px' width='32px' />  CANADA",
              verticalAlign: 'bottom',
              style: {
                fontFamily: this.fontFamily,
                fontWeight: 'bold',
                marginLeft: '8px',
                color: 'black',
              },
            },
            tooltip: {
              formatter: function () {
               return  `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`;
              }
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },
            series: [{
              name: 'Basemap',
              mapData: Canadamap,
              borderColor: '#f1a691 ',
              nullColor: 'white',
              showInLegend: false
            }, {
              type: 'mapbubble',

              data: mapArrayCanada,
              maxSize: '5%',
              color: '#b62027 '
            }]
          });
        }
        {
          const HighchartsMexico = require('highcharts/highmaps.js'),
            Mexicomap = require('@highcharts/map-collection/countries/mx/mx-all.geo.json');
          HighchartsMexico.mapChart(this.areaMapMexico.nativeElement, {
            chart: {
              type: 'map',
              height: 370,
              width: 370,
              backgroundColor: 'lightgray'
            },

            title: {
              useHTML: true,
              text: "<img src='/assets/images/mexicoflag.png'   height='19px' width='32px' />  MEXICO",
              verticalAlign: 'bottom',
              style: {
                fontFamily: this.fontFamily,
                fontWeight: 'bold',
                marginLeft: '8px',
                color: 'black',
              },
            },
            tooltip: {
              formatter: function () {
                return `<b>${this.point.parentState}</b><br/>Membership Count: <b>${this.point.membershipCount}</b>`;
              }
            },
            credits: {
              enabled: false
            },
            legend: {
              enabled: false
            },

            series: [{
              name: 'Basemap',
              mapData: Mexicomap,
              borderColor: '#f1a691 ',
              nullColor: 'white',
              showInLegend: false
            }, {
              type: 'mapbubble',
              data: mapArrayMexico,
              maxSize: '5%',
              color: '#b62027 '
            }]
          });

        }

      }
    }
    )
    this.spinnerService.hide();
  }


  /** get banner image list
   * @class BannerImage
   * @method getdiBannerList
   */
  getnaacBannerList() {
    this.spinnerService.show();
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": "",
    }
    this.naacService.getnaacBannerList(this.LandingPaginationDTO).subscribe(data => {
      this.naacDetailsList = data.content;
      if (this.naacDetailsList != null && this.naacDetailsList !== undefined) {
        this.spinnerService.hide();
        this.imageURL = '';
        this.visionStatement = '';
        this.affinityGoal = '';
        for (const naacs of this.naacDetailsList) {
          if (this.selectedNaacId === naacs.naacId) {
            this.imageURL = naacs.naacName;
            this.visionStatement = naacs.naacVision;
            this.affinityGoal = naacs.naacAffinity;
            this.naacLogo = naacs.naacLogoUrl;
            break
          }
        }
      }
    })

  }

  /** get list of naac news
* @class NaacComponent
* @method getnaacnewsList
*/
  getnaacnewsList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "modifiedDateTime",
      "uid": ""
    }

    this.naacService.getnaacnewsList(this.LandingPaginationDTO).subscribe(data => {
      this.naacNewsList = data.content;
      if (this.naacNewsList !== null && this.naacNewsList !== undefined) {
        this.spinnerService.hide();
        this.selectedNewsList = [];
        for (const news of this.naacNewsList) {
          if (this.selectedNaacId === news.naacId) {
            this.selectedNewsList.push(news)
          }
        }

        for (const list of this.selectedNewsList) {
          list.wordCount = 0;
          if (list.naacImageCheck === false) {
            list.naacNewsUrl = '/assets/images/news_logo.jpg';
          }
        }
        for (const list1 of this.selectedNewsList) {
          if (list1.naacNewsDesc !== null && list1.naacNewsDesc !== '' && list1.naacNewsDesc !== undefined) {
            list1.wordCount = list1.naacNewsDesc.split(" ").length;
            if (list1.wordCount >= 30) {
              list1.minWord = list1.naacNewsDesc.slice(0, 160);
              list1.minWord = list1.minWord + '...';
              list1.showFullWord = false;
            }
            else{
              list1.showFullWord = true;
            }
          }
          else {
            list1.showFullWord = true;
          }
        }
        const element = document.getElementById('newsId');
        if(this.selectedNewsList.length===2){
          element.className='news-scroll';
          element.style["animationDuration"]=`${this.selectedNewsList.length * 6}s`;
        }
       else if(this.selectedNewsList.length>2){
        element.className='news-scroll';
        element.style["animationDuration"]=`${this.selectedNewsList.length * 3.5}s`;
       }else{
          element.className="none";
        }
      }
    })
  }
  /** For download files of the resources
     * @class NaacHomePage Component
     * @method downloadAttachments
     */
  downloadAttachments(urls, i) {
    const extension = urls.substring(urls.lastIndexOf('.') + 1);
    const link = document.getElementById('downloadFiles' + i);
    link.setAttribute('href', urls);
    link.setAttribute('download', urls);
    if (extension.includes('mp4')) {
      link.setAttribute('target', '_blank');
    }
    if (extension === 'pdf' || 'csv') {
      link.setAttribute('target', '_blank');
    }
  }
  /** get Folder list
    * @class AdditionalResourceComponent
    * @method getnaacFolderList
    */
  public getnaacFolderList() {
    const landingData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "ASC",
      "sortProperty": "folder_order",
      "uid": ""
    }

    this.naacService.getNaacDocumentsFolder(landingData).subscribe(data => {
      this.naacFolderList = data.content;
      this.selectedFolder = [];
      for (const folderList of this.naacFolderList) {
        if (this.selectedNaacId === folderList.naacId) {

          this.selectedFolder.push(folderList);

        }
      }

      for (const select of this.selectedFolder) {
        select.Maxmin = '+';
      }
    });
  }

  /** For displaying files based on folder selection
     * @class EventViewDetailsComponent
     * @method selectnaacFolder
     */
  selectnaacFolder(folderid) {
    this.fileList = [];

    for (const resource of this.selectedResourceList) {
      if (resource.folderId === folderid) {
        this.fileList.push(resource);
      }
    }

    for (const folderList of this.selectedFolder) {
      if (folderList.folderId === folderid) {
        if (folderList.showFolder === false || folderList.showFolder === undefined || folderList.showFolder === null) {
          folderList.Maxmin = '-';
          folderList.showFolder = true;
        }
        else {
          folderList.Maxmin = '+';
          folderList.showFolder = false;
        }
      }
      else {
        folderList.Maxmin = '+';
        folderList.showFolder = false;
      }
    }
  }


  /** get list of naac resource
   * @class NaacComponent
   * @method getNaacResouceList
   */
  getNaacResouceList() {
    this.spinnerService.show()
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacHomePage" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "folderOrder",
      "uid": ""
    }

    this.naacService.getnaacResource(this.LandingPaginationDTO).subscribe(data => {
      this.naacResourceList = data.content;
        if (this.naacResourceList != null && this.naacResourceList !== undefined){
          this.spinnerService.hide();
          this.selectedResourceList = [];
         for (const list of this.naacResourceList) {
          if (this.selectedNaacId === list.naacId) {
            this.selectedResourceList.push(list)
          }
          }
        } 
    }
    )
  }
  /** get list of naac Reteam
   * @class NaacComponent
   * @method getnaacREteamList
   */
  getnaacREteam() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacHomePage" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "regionalOrder",
      "uid": ""
    }
    this.naacService.getnaacREteam(this.LandingPaginationDTO).subscribe(data => {
      this.naacReTeamList = data.content;
      if (this.naacReTeamList != null && this.naacReTeamList !== undefined){
        this.spinnerService.hide();
      }
      this.selectedReTeamList = [];
      for (const re of this.naacReTeamList) {
        if (this.selectedNaacId === re.naacId) {
          this.selectedReTeamList.push(re)
        }
      }
    }
    )
  }



  /** For displaying full description
       * @class NaacComponent
       * @method showFullDesc
       */
  showFullDesc(newsid) {
    for (const newsList of this.selectedNewsList) {
      if (newsList.naacNewsId === newsid) {
        newsList.showFullWord = true;
      }
    }
  }

  /** For adding 365 days to current day
     * @class NaacHomePageComponent
     * @method addDays
     * @params Date, number
     */
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  //Event details
  getEventDetails() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    const fromDate = this.datePipe.transform(new Date, ConstantValues.dateFormats.dateFormat);
    const toDate = this.datePipe.transform(this.addDays(new Date, 365), ConstantValues.dateFormats.dateFormat);


    this.LandingPaginationDTO = {
      "filter": {
        "naacAffinityId": this.naacAffinityId,
        "siteId": 0,
        "fromDate": fromDate,
        "toDate": toDate
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 3,
      "sortDirection": "ASC",
      "sortProperty": "event_create_date",
      "uid": ""
    }

    this.naacService.getNaacEvents(this.LandingPaginationDTO).subscribe(data => {
      this.upcomingeventsinfo = (data.content) ? data.content : '';
      if (this.upcomingeventsinfo.length > 0) {
        this.eventdetails1 = this.upcomingeventsinfo[0].description;
        this.eventName = this.upcomingeventsinfo[0].eventName;
        this.eventId = this.upcomingeventsinfo[0].eventId;
      } else {
        this.eventdetails1 = '';
        this.eventName = 'No upcoming events available';
        this.eventId = '';
      }


    })

  }


  /** For displaying the events name and description on clicking of events
 * @class BpgSiteHomePageComponent
 * @method openeventsDetails
 * @param event_id
 */
  openeventsDetails(eventid) {

    document.getElementById("event_description_div").scrollIntoView({ behavior: "smooth", block: "center" });
    for (let i = 0; i < this.upcomingeventsinfo.length; i++) {
      if (eventid === this.upcomingeventsinfo[i].eventId) {

        this.eventId = eventid;
        document.getElementById(`eventlist${i}${i}`).classList.add("hideArrow");
        this.eventName = this.upcomingeventsinfo[i].eventName;
        this.eventdetails1 = this.upcomingeventsinfo[i].description;
      }
      if (eventid !== this.upcomingeventsinfo[i].eventId) {
        if (i === 0) {
          document.getElementById(`eventlist${i}${i}`).classList.add("hideDiv");
        }
        document.getElementById(`eventlist${i}${i}`).classList.remove("hideArrow");
      }
    }
  }

  /** For redirecting to events calendar list view
   * @class BpgSiteHomePageComponent
   * @method viewMoreEvents
   */
  viewMoreEvents() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    const navigatePath = "naacHome";
    const idsAndNavigatePath = {
      'siteId': null,
      'naacAffinityId': this.naacAffinityId,
      'path': navigatePath
    }
    this.data.selectedSiteIdAndPath(idsAndNavigatePath);
    this.router.navigate(['events-list-view']);
  }

  /** For displaying complete description when 'view details' is clicked
   * @class BpgSiteHomePageComponent
   * @method viewMoreEventsDetails

   */
  viewMoreEventsDetails(eventid) {
    sessionStorage.setItem(this.iconKeyList, "SITELIST");
    for (const upevent of this.upcomingeventsinfo) {
      if (upevent.eventId === eventid) {
        this.eventDetails = upevent;
        Object.assign(this.eventDetails, { 'componentName': 'naacHomePage' });
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        this.router.navigate(['event-view-details']);
      }
    }
  }

}


